<template>
  <el-dropdown v-if="userinfo" trigger="hover">
    <el-image :src="userinfo.avatar" fit="contain">
      <i slot="error" class="el-icon-user-solid" />
    </el-image>

    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item class="account-container" disabled>
        <el-image :src="userinfo.avatar" fit="contain">
          <i slot="error" class="el-icon-user-solid" />
        </el-image>

        <div>
          <div>
            {{ userinfo.first_name }} {{ userinfo.last_name }}
          </div>
          <div v-if="userinfo.phone">
            {{ userinfo.phone }}
          </div>
        </div>
      </el-dropdown-item>

      <el-dropdown-item divided @click.native="logout">
        {{ $t('common.logout') }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'TcDropdownAccount',
  computed: {
    ...mapGetters([
      'userinfo'
    ])
  },
  methods: {
    async logout() {
      await this.$store.dispatch('user/logout')
      window.location.replace(this.$store.state.settings.outerPage.home)
    }
  }
}
</script>

<style scoped lang="scss">
.el-image {
  width: 24px;
  height: 24px;
  border-radius: 5px;

  .el-icon-user-solid {
    font-size: 24px;
  }
}

.el-dropdown-menu__item {
  text-align: center;
}

.account-container {
  display: flex;
  align-items: center;
  grid-gap: 15px;
  text-align: left;
}
</style>
